import { useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'

const useIsDesktop = () => {
  const theme = useTheme()
  return useMediaQuery(theme.breakpoints.up('md'))
}

export default useIsDesktop